<app-common-modal-form
  header="Link to External Entity"
  icon="ic-bell-20"
  [isCustomFooter]="true"
  (close)="close()"
>
  <div class="body-container">
    <app-grid-client-side
        [colDefs]="$any(colDefs)"
        [rowData]="externalEntities"
        [suppressRowClickSelection]="true"
        [loading]="loadingGrid"
        [paginationPageSize]="5"
        (select)="selectEntities($event)"
        (gridReady)="onGridReady($event)"
    />
  </div>

  <div class="custom-footer d-flex gap-24">
    @if (!isEntityNumberEqual) {
      <div class="message">
        <span>{{differentEnitityNumbersMessage}}</span> <br>
        <span>To continue, click the "Link Identity" button.</span>
      </div>
    }
    @if (moreThenOneEntitySelected) {
      <div class="message">
        <span>You can link only one entity at a time.</span>
      </div>
    }
    <div class="button-row">
      <app-button
        text="Link Identity"
        iconClass="icon ic-link-20"
        [loading]="loadingLinkIdentity"
        [isDisabled]="isLinkButtonEnabled"
        (clickBtn)="linkIdentity()"
      ></app-button>

      <app-button
        text="Cancel"
        btnColor="white"
        (clickBtn)="close()"
      ></app-button>
    </div>
  </div>
</app-common-modal-form>
